<template>
  <v-container>
      <div class="box mt-10 mb-10">
        <h1 class="text-center mb-5">Chương trình</h1>
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel v-for="(item, i) in time" :key="i">
            <v-expansion-panel-header style="font-size:1.5rem;font-weight:bold" class="title">
              {{ item.date }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ul>
                <li v-for="i in item.event" :key="i">{{ i }}</li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      panel: [0, 1,2,3,4,5],
      time: [
        {
          date:
            "Thứ 7, Ngày 14/11/2020 (Trường ĐH Khoa học Tự nhiên, ĐHQGHN)",
          event: [
            "08:45 – 10:15 : Đại số ma trận cho cơ học lượng tử (PGS. TS. Đỗ Vân Nam)",
            "10:30 – 12:00 : Thực tập đại số ma trận (PGS. TS. Đỗ Vân Nam)",
            "13:45 – 15:15 : Cơ học lượng tử 1 (PGS. TS. Nguyễn Bá Ân)",
            "15:30 – 17:00 : Cơ học lượng tử 2 (PGS. TS. Nguyễn Bá Ân)",
          ],
        },
        {
          date:
            "Chủ nhật, Ngày 15/11/2020 (Trường ĐH Khoa học Tự nhiên, ĐHQGHN)",
          event: [
            "08:45 – 10:15 : Tính toán lượng tử 1 (TS. Nguyễn Văn Duy)",
            "10:30 – 12:00 : Tính toán lượng tử 2 (TS. Nguyễn Văn Duy)",
            "13:45 – 15:15 : Ngôn ngữ lập trình lượng tử (TS. Nguyễn Quốc Hưng)",
            "15:30 – 17:00 : Thuật toán  Deutsch Jozsa (TS. Nguyễn Quốc Hưng)",
          ],
        },
        {
          date:
            "Thứ 2, Ngày 16/11/2020 (Trường ĐH Khoa học Tự nhiên, ĐHQGHN)",
          event: [
            "16:30 – 18:00: Thuật toán Grover (TS. Nguyễn Quốc Hưng, Trần Minh Đức)",
            "18:15 – 19:45: Thực hành D-J và Grover  (TS. Nguyễn Quốc Hưng, Trần Minh Đức)",
          ],
        },
        {
          date:
            "Thứ 3, Ngày 17/11/2020 (Trường ĐH Khoa học Tự nhiên, ĐHQGHN)",
          event: [
            "16:30 – 18:00: Máy tính lượng tử (TS. Nguyễn Quốc Hưng)",
            "18:15 – 19:45: Qubit siêu dẫn (TS. Nguyễn Văn Duy)",
          ],
        },
        {
          date: "Thứ 7, Ngày 21/11/2020 (Nhà khách Đại học Quốc gia Hà Nội, Ba Vì)",
          event: [
            "08:45 – 10:15 : Biến đổi Fourier lượng tử (TS. Nguyễn Văn Duy, Nguyễn Công Hà)",
            "10:30 – 12:00 : Thuật toán Shor (TS. Nguyễn Văn Duy, Nguyễn Công Hà)",
            "13:45 – 15:15 : Thuật toán Shor (TH) (TS. Nguyễn Văn Duy, Nguyễn Công Hà)",
            "15:30 – 17:00 : Thuật toán Shor (TH) + hackathon (TS. Nguyễn Văn Duy, Nguyễn Công Hà)",
          ],
        },
        {
          date: "Chủ nhật, Ngày 22/11/2020 (Nhà khách Đại học Quốc gia Hà Nội, Ba Vì)",
          event: [
            "08:45 – 10:15 : Mô phỏng lượng tử (TS. Nguyễn Quốc Hưng, Trần Minh Đức)",
            "10:30 – 12:00 : Thực hành mô phỏng lượng tử (TS. Nguyễn Quốc Hưng, Trần Minh Đức)",
            "13:45 – 15:15 : Qubit siêu dẫn (Nâng cao) - TS. Nguyễn Bảo Long",
            "15:30 – 17:00 : Tổng kết khóa học",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.box {
  background: white;
  padding: 2rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px;
    @media (max-width: 460px) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 10px;
    padding-left:5px ;
    padding-right:5px ;
  }
}
.title{
    @media (max-width: 460px) {
    font-size: 1rem!important;
    line-height: 1.5rem!important;
  }
}
</style>
